export const DOT_CHARACTER = '•' as const;
